import React from "react";
import LoadingWithLable from "../../../../../ReusableComponents/Loading/LoadingWithLable";
import useSearchPagination from "../../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { Link } from "react-router-dom";
import { RiDownloadCloud2Fill, RiDownloadCloudLine } from "react-icons/ri";
import { MdCloudDownload } from "react-icons/md";
import { FiDownloadCloud } from "react-icons/fi";

export default function ListPayments({
  payments = [],
  editData,
  deleteData,
  loading,
  titles = [],
}) {
  const { NoDataFound, Pagination, PaginationIndex, Search, currentList } = useSearchPagination(payments || []);
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    
    return `${day}-${month}-${year}`;
  };
  return (
    <div className="py-2 px-3 uppercase">
      <div className="sm:block block text-center  md:hidden lg:hidden">
        <p className=" text-xl font-semibold">Payment List</p>
      </div>
      <div className="flex my-2 justify-between items-center flex-wrap">
        <div>
          <Search
            searchKey={[
              "payment_id",
              "reference_number",
              "amount",
              "category",
              "transaction_date",
              "user.name",
            ]}
          />
        </div>
        <div className="hidden sm:hidden md:inline-block lg:inline-block">
          <p className=" text-xl font-semibold">Payment List</p>
        </div>
        {/* <div className="mr-5 hover:scale-105 border-solid border-black border p-2 bg-white rounded-lg shadow-xl cursor-pointer "> */}
        {/* <FiDownloadCloud/> */}
        <div className="flex flex-col justify-end gap-2">
          <button className="btn-md shadow-lg  rounded-lg  font-bold bg-white text-dark hover:text-white hover:bg-red ">
            DOWNLOAD
          </button>
          <p className="text-sm w-full text-right font-medium mb-1  block">{`Slide / scroll to right >`}</p>
        </div>
      </div>

      <div
        className={`grid justify-items-center grid-cols-table-8 auto-cols-min gap-5 p-6 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md `}
      >
        {titles.map((title, index) => (
          <p key={index} className="font-semibold uppercase">
            {title}
          </p>
        ))}
        {loading && <LoadingWithLable className="col-span-8" />}
        <NoDataFound customClass="col-span-8" />
        {!loading && payments?.length <= 0 && (
          <p className="col-span-8">No Data found</p>
        )}
        {currentList?.map((payment, index) => (
          <React.Fragment key={payment?.id}>
            <PaginationIndex index={index} />
            <p>{payment.payment_id}</p>
            <p>{payment.reference_number}</p>
            <p>{payment?.amount}</p>
            <p>{payment?.user?.name}</p>
            <p>{payment?.category}</p>
            <p>{payment?.transaction_date}</p>
            <div className="flex items-center gap-2">
              <Link to={payment?.file} target="_blank">
                <button
                  className={`p-1 px-2 rounded-md ring-1 ring-red bg-red hover:scale-105 text-white`}
                >
                  View File
                </button>
              </Link>
            </div>
            <hr
              className={`border-[1.5px] border-slate-100  w-full col-span-8 `}
            />
          </React.Fragment>
        ))}
      </div>
      <Pagination />
    </div>
  );
}